



// Profilesidebarnew.jsx
import React, { useState, useEffect } from 'react';
import { useNavigate } from "react-router-dom";
import { FiLogOut } from "react-icons/fi";
import './Profilesidebar.css';

const Sidebar = ({ isOpen, activeTab, onTabChange, onToggle, isMobileOpen }) => {
    const menuItems = [
        { id: 'Profile', label: 'Profile', icon: '👤' },
        { id: 'Wallet', label: 'Wallet', icon: '🛍️' },
        { id: 'Orders', label: ' My Orders', icon: '📦' },
        { id: 'Favorites', label: 'Favorites', icon: '❤️' },
        { id: 'Support', label: 'Support', icon: '💁' },
        // { id: 'Settings', label: 'Settings', icon: '⚙️' },
        { id: 'Notifications', label: 'Notifications', icon: '🔔' },
    ];
    const navigate = useNavigate();

    const [userDetails, setUserDetails] = useState({
        userName: "",
        emailId: "",
        mobileNumber: "",
        image: "",
        gender: "",
    });

    useEffect(() => {
        const userId = localStorage.getItem("userId");
        const token = localStorage.getItem("authToken");

        if (!userId) return;

        const apiUrl = `https://backend.maamaas.com/subscription/api/user/getprofile/${userId}`;

        const fetchProfile = async () => {
            try {
                const response = await fetch(apiUrl, {
                    headers: token ? { Authorization: `Bearer ${token}` } : {},
                });

                if (!response.ok) throw new Error("Failed to fetch profile");

                const data = await response.json();

                setUserDetails({
                    userName: data.userName || "",
                    emailId: data.emailId || "",
                    mobileNumber: data.mobileNumber || "",
                    image: data.image || "",
                    gender: data.gender || "",
                });

            } catch (err) {
                console.error(err);
            }
        };

        fetchProfile();
    }, []);

    const getIcon = (icon) => icon;

    // Get user initials for avatar
    const getUserInitials = () => {
        if (userDetails.userName) {
            return userDetails.userName.charAt(0).toUpperCase();
        }
        return 'U';
    };

    // Get user display name with title
    const getUserDisplayName = () => {
        if (!userDetails.userName) return "User Profile";
        const title = userDetails.gender === "female" ? "Ms." :
            userDetails.gender === "male" ? "Mr." : "";
        return `${title} ${userDetails.userName}`;
    };



    const handleDeleteAccount = async () => {
        const userId = localStorage.getItem("userId");
        const token = localStorage.getItem("authToken");

        if (!userId) return;

        const confirm = window.confirm("Are you sure you want to delete account?");
        if (!confirm) return;

        try {
            const response = await fetch(
                `https://backend.maamaas.com/subscription/api/user/delete/account/${userId}`,
                {
                    method: "DELETE",
                    headers: {
                        "Content-Type": "application/json",
                        Authorization: token ? `Bearer ${token}` : "",
                    },
                }
            );

            if (response.ok) {
                alert("✔ Account deleted successfully");
                localStorage.clear();
                navigate("/");
            } else {
                const errMsg = await response.text();
                throw new Error(errMsg || "Failed to delete account");
            }
        } catch (err) {
            console.error(err);
        }
    };

    return (
        <>
            {/* Mobile overlay with unique class */}
            {isMobileOpen && <div className="psn-sidebar-overlay" onClick={onToggle} />}

            <div className={`psn-sidebar ${!isOpen ? 'psn-collapsed' : ''} ${isMobileOpen ? 'psn-mobile-open' : ''}`}>
                <div className="psn-sidebar-header">
                    <div className="psn-logo">
                        {isOpen ? (
                            <h2 className="psn-logo-text">
                                {getUserDisplayName()}
                            </h2>
                        ) : (
                            <div className="psn-logo-mini">🍽️</div>
                        )}
                    </div>
                    <button className="psn-collapse-btn" onClick={onToggle} aria-label="Toggle sidebar">
                        ☰
                    </button>
                </div>

                <nav className="psn-sidebar-nav">
                    {menuItems.map(item => (
                        <button
                            key={item.id}
                            className={`psn-nav-link ${activeTab === item.id ? 'psn-active' : ''}`}
                            onClick={() => onTabChange(item.id)}
                        >
                            <span className="psn-nav-icon">{getIcon(item.icon)}</span>
                            {isOpen && <span className="psn-nav-text">{item.label}</span>}
                            {!isOpen && <span className="psn-nav-tooltip">{item.label}</span>}
                        </button>
                    ))}
                </nav>

                <div className="psn-sidebar-footer">
                    <div className="psn-user-info">
                        <div className="psn-user-avatar">{getUserInitials()}</div>
                        {/* <div className="psn-user-avatar">{getUserInitials()}</div> */}

                        {isOpen && (
                            <div className="psn-user-details">
                                <div className="psn-user-name">
                                    {userDetails.userName || "Guest User"}
                                </div>

                            </div>
                        )}

                        {/* 🔴 Logout Icon */}
                        <div className="logout-icon" onClick={handleDeleteAccount}>
                            <FiLogOut />
                        </div>
                    </div>
                    {!isOpen && <span className="psn-nav-tooltip psn-user-tooltip">{userDetails.userName || "Guest User"}</span>}
                </div>
            </div>
        </>
    );
};

export default Sidebar;